const INSURANCE_COMPONENTS = {
    insurance_view: {
        permissions: [{ permission_code: "INSURANCE_VIEW" }],
    },
    insurance_download: {
        permissions: [{ permission_code: "INSURANCE_DOWNLOAD" }],
    },
    insurance_search: {
        permissions: [{ permission_code: "INSURANCE_SEARCH" }],
    },
    insurance_filters: {
        permissions: [{ permission_code: "INSURANCE_FILTERS" }],
    },
}

module.exports = {
    INSURANCE_COMPONENTS
}